import { render, staticRenderFns } from "./details-info.vue?vue&type=template&id=62efb9f2&scoped=true"
import script from "./details-info.vue?vue&type=script&lang=ts"
export * from "./details-info.vue?vue&type=script&lang=ts"
import style0 from "./details-info.vue?vue&type=style&index=0&id=62efb9f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62efb9f2",
  null
  
)

export default component.exports